import { render, staticRenderFns } from "./DocumentSetSb.vue?vue&type=template&id=543fe8d7&scoped=true"
import script from "./DocumentSetSb.vue?vue&type=script&lang=js"
export * from "./DocumentSetSb.vue?vue&type=script&lang=js"
import style0 from "./DocumentSetSb.vue?vue&type=style&index=0&id=543fe8d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543fe8d7",
  null
  
)

export default component.exports